import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import {
  User,
  Settings,
  HelpCircle,
  LogOut,
  ChevronDown,
  Shield,
  Mail
} from 'lucide-react'
import "./ProfileMenu.css"
import { useSelector } from "react-redux";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)
  const [userName, setUserName] = useState("")
  const [userEmail, setUserEmail] = useState("")
  const [userRole, setUserRole] = useState("")

  const user = useSelector((state) => state?.users.users);

  useEffect(() => {
    // Get user data from sessionStorage or props
    // const storedUserName = sessionStorage.getItem('userName') || sessionStorage.getItem('username')
    // const storedUserEmail = sessionStorage.getItem('userEmail') || sessionStorage.getItem('email')
    // const storedUserRole = sessionStorage.getItem('userRole') || sessionStorage.getItem('role')

    // TODO: check if user.name actually exists? Also, userType needs to be changed to something more readable.
    const storedUserName = user.name || user.UserName;
    const storedUserEmail = user.email || user.UserEmail;
    const storedUserRole = user.userType || user.UserType;

    if (storedUserName) setUserName(storedUserName)
    if (storedUserEmail) setUserEmail(storedUserEmail)
    if (storedUserRole) setUserRole(storedUserRole)
  }, [])

  const getInitials = (name) => {
    if (!name) return "AU"
    const names = name.split(' ')
    if (names.length >= 2) {
      return (names[0][0] + names[1][0]).toUpperCase()
    }
    return name.substring(0, 2).toUpperCase()
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="profile-dropdown-container"
      >
        <DropdownToggle
          className="profile-dropdown-toggle"
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="profile-trigger">
            <div className="profile-avatar">
              <div className="profile-avatar-image">
                {getInitials(userName)}
              </div>
              <div className="profile-avatar-status"></div>
            </div>
            <div className="profile-info">
              <div className="profile-name">{userName}</div>
              <div className="profile-role">{userRole}</div>
            </div>
            <ChevronDown className={`profile-chevron ${menu ? 'open' : ''}`} />
          </div>
        </DropdownToggle>

        <DropdownMenu className="profile-dropdown-menu">
          {/* User Info Header */}
          <div className="profile-dropdown-header">
            <div className="profile-dropdown-avatar">
              {getInitials(userName)}
            </div>
            <div className="profile-dropdown-info">
              <div className="profile-dropdown-name">{userName}</div>
              <div className="profile-dropdown-email">{userEmail}</div>
            </div>
          </div>

          <div className="profile-dropdown-divider"></div>

          {/* Menu Items */}
          <div className="profile-dropdown-items">
            <Link to="/profile" className="profile-dropdown-item" onClick={() => setMenu(false)}>
              <div className="profile-item-icon">
                <User size={18} />
              </div>
              <div className="profile-item-content">
                <div className="profile-item-label">{props.t("My Profile")}</div>
                <div className="profile-item-description">View and edit profile</div>
              </div>
            </Link>

            <Link to="/settings" className="profile-dropdown-item" onClick={() => setMenu(false)}>
              <div className="profile-item-icon">
                <Settings size={18} />
              </div>
              <div className="profile-item-content">
                <div className="profile-item-label">{props.t("Settings")}</div>
                <div className="profile-item-description">Manage preferences</div>
              </div>
            </Link>

            <Link to="/usermanagement" className="profile-dropdown-item" onClick={() => setMenu(false)}>
              <div className="profile-item-icon">
                <Shield size={18} />
              </div>
              <div className="profile-item-content">
                <div className="profile-item-label">{props.t("User Management")}</div>
                <div className="profile-item-description">Manage users & access</div>
              </div>
            </Link>

            <Link to="/help" className="profile-dropdown-item" onClick={() => setMenu(false)}>
              <div className="profile-item-icon">
                <HelpCircle size={18} />
              </div>
              <div className="profile-item-content">
                <div className="profile-item-label">{props.t("Help & Support")}</div>
                <div className="profile-item-description">Get assistance</div>
              </div>
            </Link>
          </div>

          <div className="profile-dropdown-divider"></div>

          {/* Logout */}
          <div className="profile-dropdown-footer">
            <Link to="/logout" className="profile-dropdown-logout" onClick={() => setMenu(false)}>
              <div className="profile-logout-icon">
                <LogOut size={18} />
              </div>
              <span className="profile-logout-text">{props.t("Sign Out")}</span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
